// Display formatting for phones already normalized to E.164 (+5548999998888).
// Used everywhere the panel renders a stored phone · keeps the visual format
// consistent (and friendlier to read) without changing the underlying value.

import { formatBrazilianPhone } from './phone-mask';

/**
 * Format a stored E.164 BR phone for display.
 *   "+5548999998888" → "(48) 99999-8888"
 *   "+554833334444"  → "(48) 3333-4444"
 *   non-BR / invalid → returns the input untouched
 */
export function formatPhoneDisplay(phoneE164: string | null | undefined): string {
  if (!phoneE164) return '';
  if (phoneE164.startsWith('+55')) {
    return formatBrazilianPhone(phoneE164.slice(3));
  }
  return phoneE164;
}
